import { ExportMenu, HEAD_ACTION_QUIET } from '@/components/admin/sessions/export-menu';
import { ReviewEntryButton } from '@/components/admin/sessions/review-entry-button';
import type { SessionRow } from '@matter_extractor/shared';
import { Link } from '@tanstack/react-router';

/**
 * The three controls at the head of the conversation (§12.3, §12.6): the entry
 * to the review (relecture.md §3.2, issue #187), then the export, then the way
 * back.
 *
 * « Exporter en » is the parcours' own menu (issue #173): it replaced the lone
 * « Exporter en markdown » of #71, and the way back took its shape - 14 px,
 * corners of 8 px - rather than the 16 px and 16 px it had: one component, one
 * style. A component of its own rather than JSX in the route because
 * `vitest.config.ts` leaves `src/routes/**` out of the report, and « the lone
 * button is gone » is a claim a test has to be able to make.
 */

export interface ConversationActionsProps {
  readonly session: SessionRow;
}

export function ConversationActions({ session }: ConversationActionsProps) {
  return (
    <>
      <ReviewEntryButton session={session} />
      <ExportMenu sessionId={session.id} trashed={session.deletedAt !== null} />
      <Link
        to="/admin/sessions/$sessionId"
        params={{ sessionId: session.id }}
        className={HEAD_ACTION_QUIET}
      >
        Retour au parcours
      </Link>
    </>
  );
}
